export const DEAL_TYPE_DISPLAY_NAME = "dealTypeDisplayName";
